
import Vue from 'vue';
import ArrowDown from '../../../Icons/ArrowDownCircular.vue';
import helper from '../../../utils/helper';
/**
- When putting selected item at first state, <b>must also</b> pass prop <b>selectionOptions</b>. 
- Value object should be in this format: <b>{label: "MYR", value: "malaysian", icon: "imageURL"}</b> icon is optional, no need to attach if selection has no icon
**/
export default Vue.extend<any, any, any, any>({
  name: 'Dropdown',
  data() {
    return {
      selectedItem: null,
      open: false
    };
  },
  components: {
    ArrowDown
  },
  props: {
    /**
     * Value of dropdown input
     */
    value: {
      type: Object,
      default: () => {}
    },
    /**
     * The ID, can be string or number
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set options for the dropdown
     */
    selectionOptions: {
      type: Array,
      default: () => [
        {
          label: '',
          value: ''
        }
      ]
    },
    /**
     * Set placeholder in the input
     */
    placeholder: {
      type: String,
      default: 'Select here'
    },
    /**
     * Set dropdown to disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set dropdown to be clickonly
     */
    clickonly: {
      type: Boolean,
      default: false
    },
    /**
     * To mark that the dropdown is inside input
     */
    dropdowninput: {
      type: Boolean,
      default: false
    },
    /**
     * To mark that the dropdown is for filter
     */
    filterinput: {
      type: Boolean,
      default: false
    },
    /**
     * Set dropdown on error state
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * Set dropdown on success state
     */
    success: {
      type: Boolean,
      default: false
    },
    /**
     * Set dropdown required
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * Set arrow color of the dropdown
     */
    arrowColor: {
      type: String,
      default: '#f87300'
    },
    /**
     * Set arrow icon
     */
    arrowIcon: {
      type: Object,
      default: () => ArrowDown
    },
    /**
     * Set arrow size
     */
    arrowSize: {
      type: String,
      default: '18px'
    }
  },
  watch: {
    value(val: any) {
      if (!val || helper.isEmptyObject(val)) {
        this.selectedItem = null;
      } else {
        this.selectedItem = val;
      }
    }
  },
  computed: {
    isInsideInput() {
      return this.dropdowninput || this.filterinput;
    },
    dropdownIcon() {
      if (this.isInsideInput && !this.selectedItem) {
        return this.selectionOptions[0].icon;
      }
      return this.selectedItem && this.selectedItem.icon;
    },
    containerClasses() {
      return {
        disabled: this.disabled,
        openborder: this.open,
        error: this.error,
        success: this.success
      };
    },
    menuClasses() {
      return {
        active: this.open,
        simplify: this.selectionOptions.length > 3
      };
    }
  },
  created() {
    if (this.value && Object.keys(this.value).length > 0) {
      this.selectedItem = this.value;
      this.$emit('input', this.value);
    }
    if (this.required) {
      this.$emit('inputState', this.selectedItem && this.selectedItem.value ? true : null); //if there is already a selection in dropdown, inputState turns true
    }
  },
  methods: {
    activate() {
      this.open = true;
      (this.$el as HTMLElement).focus();
    },
    deactivate() {
      this.open = false;
      if (this.required) {
        this.$emit('inputState', this.selectedItem && this.selectedItem.value ? true : false);
      }
      (this.$el as HTMLElement).blur();
    },
    handleDropdown() {
      if (this.clickonly) {
        /**
         * Method to click the dropdown
         * @event click
         * @type {function}
         */
        this.$emit('click');
      } else if (!this.disabled) {
        if (this.open) {
          this.deactivate();
        } else {
          this.activate();
        }
      }
    },
    handleSelect(val: any) {
      this.open = false;
      this.selectedItem = val;
      /**
       * Method to input the selected value
       * @event input
       * @type {function}
       */
      this.$emit('input', val);
      if (this.required) {
        /**
         * This method only works if props required is given. Meaning if the value is null, inputState = false.
         * @event inputState
         * @type {function}
         */
        this.$emit('inputState', true);
      }
    }
  }
});
